export default __webpack_public_path__ + "static/media/stethoscope.f64b38ac.svg";